var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M253.398 472.795L26.262 245.68 253.398 18.565c4.093-4.237 3.975-10.99-.262-15.083-4.134-3.992-10.687-3.992-14.82 0L3.65 238.15c-4.164 4.165-4.164 10.917 0 15.083L238.316 487.9c4.093 4.237 10.845 4.354 15.083.262 4.237-4.093 4.354-10.845.262-15.083a10.787 10.787 0 00-.262-.262v-.02z"}));
}

ArrowLeft.defaultProps = {"height":"491.66","width":"257.139","viewBox":"0 0 257.139 491.66"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
